import React from 'react'

import { Radio, Stack } from '@mantine/core'

import { SORT_FILTER_TRAIT_UNRESTRICTED_VALUE } from '../../constants'
import { DefaultThreeSidedBooleanFilterProps } from '../../hooks/useDebouncedFilterValue/use-debounced-filter-value'
import useDebouncedFilterValue from '../../hooks/useDebouncedFilterValue/useDebouncedFilterValues'

const DefaultThreeSidedBooleanFilter = ({
  sortFilter,
  filterDefinition,
}: DefaultThreeSidedBooleanFilterProps): React.ReactElement => {
  const { label, unrestricedLabel, trueLabel, falseLabel } = filterDefinition

  const { value, onChange } = useDebouncedFilterValue<string>({
    sortFilter,
    filterDefinition,
  })

  return (
    <Radio.Group
      styles={{
        label: {
          marginBottom: 0,
          fontWeight: 'normal',
        },
      }}
      value={value}
      onChange={onChange}
      label={label}
    >
      <Stack spacing="xs">
        <Radio
          styles={{
            label: {
              marginBottom: 0,
              fontWeight: 'normal',
            },
          }}
          value={SORT_FILTER_TRAIT_UNRESTRICTED_VALUE}
          label={
            unrestricedLabel ??
            i18n.t('unrestricted_default_label', 'Ohne Einschränkung') //t('unrestricted_default_label')
          }
        />
        <Radio
          styles={{
            label: {
              marginBottom: 0,
              fontWeight: 'normal',
            },
          }}
          value="1"
          label={trueLabel}
        />
        <Radio
          styles={{
            label: {
              marginBottom: 0,
              fontWeight: 'normal',
            },
          }}
          value="0"
          label={falseLabel}
        />
      </Stack>
    </Radio.Group>
  )
}

export default DefaultThreeSidedBooleanFilter
